import { Box, Stack, Typography } from "@mui/material";
import { PricingPlanFeatureItem } from "../PricingPlanFeatureItem";
import { TPricingPlanFeatures } from "../../../../features/pricingPlans/pricingPlans.types";

type TPricingPlanFeatureGroupProps = {
  features: TPricingPlanFeatures;
};

export const PricingPlanFeatureGroup = ({
  features,
}: TPricingPlanFeatureGroupProps) => {
  const { productAnalyzer } = features;

  const lookups =
    productAnalyzer.lookups === -1
      ? "Unlimited Lookups"
      : `${productAnalyzer.lookups} Lookups Per Month`;

  return (
    <Stack gap={3}>
      <Box>
        <Typography mb={1.6} fontSize={14} fontWeight={600}>
          Product Analyzer
        </Typography>
        <Stack gap={1.2}>
          <PricingPlanFeatureItem text={lookups} />
          {productAnalyzer.webApp && <PricingPlanFeatureItem text="Web App" />}
          {productAnalyzer.chromeExtension && (
            <PricingPlanFeatureItem text="Chrome Extension" />
          )}
        </Stack>
      </Box>
    </Stack>
  );
};
